import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReadingValue } from '../report-builder-models';

@Component({
    selector: 'measurement-point-readings',
    templateUrl: './measurement-point-readings.component.html',
    styleUrls: ['./measurement-point-readings.component.scss']
})
export class MeasurementPointReadingsComponent implements OnInit {
    @Input() measurePointId: number = 0;
    @Input() measure_point_title: string = 'point';
    @Input() readings: ReadingValue[] = [];
    @Input() totalReadings: number;
    @Input() UoM: string = '';
    @Input() tool: string = '';
    @Input() isHidden: boolean = false;
    @Input() CompartName: string ='';

    @Output() toggleData: EventEmitter<number> = new EventEmitter();

    displayToggleButton: boolean = false;

    isYesNoTool: boolean = false;
    isKPOTool: boolean = false;
    canAverage: boolean = true;

    averageLeft: number = 0;
    averageRight: number = 0;

    averageLeftWorn: number = 0;
    averageRightWorn: number = 0;

    countleft:number
    countRight:number

    IsTrackRoller:boolean=false;
    IsCrawlerFrame:boolean=false;

    constructor() { }

    ngOnInit() {
        if(this.CompartName == 'Crawler Frame Guide'){
            console.log("reading Crawler Frame Guide", this.readings)
        }

        if(this.CompartName == 'Crawler Frame Guide'){
            this.IsCrawlerFrame  = true;
        }else{
            this.IsCrawlerFrame=false;
        }
        if(this.CompartName == 'Track Rollers'){
            this.IsTrackRoller  = true;
        }else{
            this.IsTrackRoller=false;
        }
        // Check for the Yes/No tool.
        if (this.tool == 'YES or NO') {
            this.isYesNoTool = true;
            this.UoM = '';
            this.canAverage = false;
        } else if (this.tool == 'Keeper Orientation') {
            this.isKPOTool = true;
            this.canAverage = false;
            this.UoM = '';
        } else if (this.isValidTool(this.tool)) {
            this.canAverage = true;
        } else {
            this.canAverage = false;
            this.UoM = '';
        }

        // Only calculate the average if it isn't the Yes/No tool or KPO tool.
        if (!this.isYesNoTool && !this.isKPOTool && this.canAverage) {
          this.countleft = this.readings.length;
          this.countRight = this.readings.length;
          
            for (var i = 0; i < this.readings.length; i++) {
              if ( this.readings[i].left === 0) {
                this.countleft =  this.countleft - 1;
              }
                this.averageLeft += this.readings[i].left;
                this.averageLeftWorn = this.averageLeftWorn + this.readings[i].leftworn;
                
            }

            for (var j = 0; j < this.readings.length; j++) {
              if ( this.readings[j].right === 0) {
                this.countRight --;
              }
                this.averageRight += this.readings[j].right;
                this.averageRightWorn += this.readings[j].rightworn;
            }

           
          
            this.averageLeft = parseFloat((this.averageLeft / this.countleft).toFixed(2));
            this.averageRight = parseFloat((this.averageRight / this.countRight).toFixed(2));

            this.averageLeftWorn = parseFloat((this.averageLeftWorn / this.countleft).toFixed(2));
            this.averageRightWorn = parseFloat((this.averageRightWorn / this.countRight).toFixed(2));
        }

    }

    // Only supported tools are Ultrasonic Tool, Calipers, Ruler and Depth Gauge.
    isValidTool(t: string) {
        if ((t == 'UT') || (t == 'Calipers') || (t == 'Ruler') || (t == 'Depth Gauge')) {
            return true;
        } else {
            return false;
        }
    }

    // Yes = 1, No = 0
    parseYesNo(val) {
        console.log("val", val)
        if (val == 1) {
            return 'Yes';
        } else if (val == -1) {
            return 'N/A';
        }else  {
            return 'No';
        }
    }

    // A = 1, B = 2, C = 3, D = 4
    parseKPO(val) {
        if (val == 1) {
            return 'A';
        } else if (val == 2) {
            return 'B';
        } else if (val == 3) {
            return 'C';
        } else if (val == 4) {
            return 'D';
        }
    }

    toggleShowOrHide() {
        if (this.measurePointId != 0) {
            this.isHidden = !(this.isHidden);
            this.toggleData.emit(this.measurePointId);
        }
    }

    onMouseOver() {
        this.displayToggleButton = true;
    }

    onMouseOut() {
        this.displayToggleButton = false;
    }

    // this._service.getInspectionComponentMeasurementsForCompartTypeAsync(this.inspectionId, this.compartTypeId, this.side, this.uom).subscribe(r => {
    //   this.components = r;
}
